/**
 * Acquisition signals captured at landing.
 *
 * Sibling to `affiliateStore` rather than an extension of it: the two have
 * different owners and different lifetimes, and folding attribution into the
 * referral slice would let an acquisition bug surface as a referral bug.
 */
import {AcquisitionClickParam} from "@devour/client";

export interface IAcquisitionStore {
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
    referrer?: string;
    /**
     * Path + query of the page they landed on, raw. A fact, not a resolved entity — which game
     * or surface it maps to is decided read-side, so a route rename cannot rewrite history.
     */
    landingPage?: string;
    /**
     * The ad platform's click id — the query parameter's NAME and its value, kept as a pair.
     *
     * The name is stored rather than a platform because Google alone stamps three different ones
     * (`gclid`, `gbraid`, `wbraid`) that its conversion import treats as separate fields. Which
     * platform it belongs to is decided server-side; this slice only carries what was observed.
     */
    clickParam?: AcquisitionClickParam;
    clickValue?: string;
    acquisitionExpiry?: number;
}

export default {} as IAcquisitionStore;
